import React from "react";
import { useSelector } from "react-redux";
import Navbar from "../components/Navbar";
import Loader from "../components/commonComponents/Loader";

const ProfilePage = () => {
  const user = useSelector((state) => state.user.user);

  return (
    <div className="profilePage">
      <Navbar />
      {!user ? (
        <Loader />
      ) : (
        <div className="profileSection">
          <div className="profileSectionLeft">
            <div className="profileImg"></div>
            <div className="para">Name: {user.name}</div>
            <div className="para">Email: {user.email}</div>
          </div>
          <div className="profileSectionRight"></div>
        </div>
      )}
    </div>
  );
};

export default ProfilePage;
